export function formatCount(value) {
  const num = Number(value || 0)
  return num.toLocaleString('zh-CN')
}

export function formatRevenue(value) {
  const num = Number(value || 0)
  if (num >= 10000) {
    return `¥${(num / 10000).toFixed(1)}万`
  }
  return `¥${num.toLocaleString('zh-CN', { maximumFractionDigits: 2 })}`
}

export function formatYuan(value) {
  const num = Number(value || 0)
  return `¥${num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatPercent(value) {
  if (value === null || value === undefined || value === '') {
    return '—'
  }
  const num = Number(value)
  if (Number.isNaN(num)) {
    return '—'
  }
  return `${num.toFixed(1)}%`
}

export function formatGrowth(value) {
  const num = Number(value || 0)
  const prefix = num > 0 ? '+' : ''
  return `${prefix}${num.toFixed(1)}%`
}

export function growthClass(value) {
  const num = Number(value || 0)
  if (num > 0) return 'up'
  if (num < 0) return 'down'
  return 'flat'
}
